// used by the calendars widgets

import { format, addMonths } from 'date-fns/fp'
import { buildMonth } from '@events/utils'
import store from '@state/store'

const eventsCalendarMixin = {
  computed: {
    daysWithEvents() {
      if (!this.events) {
        return {}
      }
      return this.events.reduce((obj, event) => {
        obj[event.start.substring(0, event.start.indexOf(' '))] = 1
        return obj
      }, {})
    },
    weeks() {
      const dateClone = new Date(this.currentDateNow().valueOf())
      return buildMonth(dateClone, dateClone.getMonth(), (date) =>
        this.hasEventsOnDate(date)
      )
    },
  },
  methods: {
    company() {
      return this.currentUser.companies.find(({ id }) => id === this.companyId)
    },
    // previous month
    previous() {
      this.previousWithoutEmit()
    },
    previousWithoutEmit() {
      const previous = addMonths(-1, this.currentDateNow())
      store.dispatch('events/setFilterMonth', {
        companyId: this.company.id,
        monthDate: previous,
      })
      this.weekIndex = 0
    },
    // next month
    next() {
      this.nextWithoutEmit()
    },
    nextWithoutEmit() {
      const next = addMonths(1, this.currentDateNow())
      store.dispatch('events/setFilterMonth', {
        companyId: this.company.id,
        monthDate: next,
      })
      this.weekIndex = 0
    },
    filterEvents(fromDate, toDate) {
      if (!toDate) {
        toDate = fromDate
      }
      this.$emit('filter-between', fromDate.date, toDate.date)
    },
    hasEventsOnDate(date) {
      const onlyDate = format('Y-MM-dd', date)
      return !!this.daysWithEvents[onlyDate]
    },
  },
}

export default eventsCalendarMixin
